import buffer from '@turf/buffer'
import { lineString } from '@turf/helpers'
import type { Feature, MultiPolygon, Polygon } from 'geojson'
import type { LngLatCoord } from '@gpx-spa/geo-domain'

/** Meter buffer around a single line (Turf `buffer`, flat caps). */
export function bufferLineStringMeters(
  coords: LngLatCoord[],
  radiusMeters: number
): Feature<Polygon | MultiPolygon> | null {
  if (coords.length < 2 || radiusMeters <= 0) return null
  const line = lineString(coords as Array<[number, number]>)
  const b = buffer(line, radiusMeters, { units: 'meters', endType: 'flat' })
  if (!b?.geometry) return null
  return b as Feature<Polygon | MultiPolygon>
}
